var map = {
	"./Evolo 0.0.jpg": 8636,
	"./evolo.jpg": 3570,
	"./irix.jpg": 1331,
	"./lighthouse.jpg": 3097,
	"./opus.jpg": 7532,
	"./screen.jpg": 3993,
	"./square.jpg": 6132,
	"./villa H.jpg": 2765,
	"./villa M.jpg": 7460,
	"./vital cube.jpg": 2860,
	"./waterfront.jpg": 5955,
	"./zen.jpg": 7262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4990;